import { Link, graphql, useStaticQuery } from 'gatsby';
import parse from 'html-react-parser';
import React from 'react';
import NKLogotype from '../svgs/NKLogotype';

import parseLinkOption from '../../utils/LinkUtils';
import {
  contactContainer,
  divider,
  emailGrid,
  footer,
  linksContainer,
  linksDivider,
  navContainer,
  navLogo,
  privacyLink,
  socialContainer,
  socialIcon,
  subscribeGrid,
} from './Footer.module.scss';
import LinkButton from './LinkButton';
import SvgInliner from './SvgInliner';

const Footer = () => {
  const data = useStaticQuery(graphql`
    query FooterQuery {
      strapiFooter {
        address
        contact_heading
        contact_general_heading
        contact_general_email
        contact_business_heading
        contact_business_email
        contact_jobs_heading
        contact_jobs_email
        newsletter {
          heading
          text {
            data {
              text
            }
          }
        }
        newsletter_link
        socials_header
        social_icons {
          url
          image {
            alternativeText
            localFile {
              svgData
            }
          }
        }
      }
    }
  `);

  const {
    address,
    contact_heading,
    contact_general_heading,
    contact_general_email,
    contact_business_heading,
    contact_business_email,
    contact_jobs_heading,
    contact_jobs_email,
    newsletter,
    newsletter_link,
    socials_header,
    social_icons,
  } = data.strapiFooter;

  return (
    <footer className={`pagePadding pageGrid posRel `}>
      <section
        className={`gridAllColumns sectionVertPadding bgColorTrigger textColorMilk `}
        data-color={'Yonder'}
      >
        <div className={`scrollFadeIn ${footer}`}>
          <hr className={`fadeInEl ${divider} varColorMilk`} />
          <div className={`fadeInEl ${contactContainer} varColorMilk`}>
            <h2 className={`h3 pb16`}>{contact_heading}</h2>
            <ul className={`${emailGrid}`}>
              <li>
                <h3 className={`p`}>{contact_general_heading}</h3>
                {/* Animations don't work right without this div */}
                <div className={`p`}>
                  <a
                    href={`"mailto:${contact_general_email}`}
                    className={`linkHoverOnly`}
                  >
                    {contact_general_email}
                  </a>
                </div>
              </li>
              <li>
                <h3 className={`p`}>{contact_business_heading}</h3>
                <div className={`p`}>
                  <a
                    href={`"mailto:${contact_business_email}`}
                    className={`linkHoverOnly`}
                  >
                    {contact_business_email}
                  </a>
                </div>
              </li>
              <li>
                <h3 className={`p`}>{contact_jobs_heading}</h3>
                <div className={`p`}>
                  <a
                    href={`"mailto:${contact_jobs_email}`}
                    className={`linkHoverOnly`}
                  >
                    {contact_jobs_email}
                  </a>
                </div>
              </li>
            </ul>
          </div>
          <hr className={`fadeInEl ${divider} varColorMilk`} />
          <div className={`fadeInEl ${subscribeGrid} varColorMilk`}>
            <div>
              <h3 className={`h4`}>{newsletter.heading}</h3>
              <div className="pt8 pb16">
                {parse(newsletter.text.data.text, parseLinkOption)}
              </div>

              <LinkButton
                text="Subscribe"
                url={newsletter_link}
                color={'Milk'}
              />
            </div>
            <div className={`${socialContainer}`}>
              <h3 className={`h4`}>{socials_header}</h3>
              {social_icons.map(({ url, image }, index) => (
                <a
                  href={url}
                  className={`${socialIcon}`}
                  key={index}
                  target="_blank"
                  rel="noreferrer"
                >
                  <span className={`srOnly`}>{image.alternativeText}</span>
                  <SvgInliner svgContent={image.localFile.svgData} />
                </a>
              ))}
            </div>
          </div>
        </div>
      </section>
      <section
        className={`gridAllColumns textColorMilk varColorMilk bgColorTrigger bgSizeTrigger `}
        data-color={'Midnight'}
      >
        <div className={`scrollFadeIn`}>
          <div className={`posRel ${navContainer}`}>
            <Link to={`/`} className={`fadeInEl ${navLogo}`}>
              <span className={`srOnly`}>Night Kitchen Interactive</span>
              <NKLogotype />
            </Link>
            <p className={`pt16`}>{address}</p>
            <hr
              className={`fadeInEl ${divider} ${linksDivider} varColorMilk`}
            />
            <ul className={`fadeInEl ${linksContainer} varColorMilk`}>
              <li>
                <Link to={`/work`} className={`linkHoverOnly`}>
                  Work
                </Link>
              </li>
              <li>
                <Link to={`/approach`} className={`linkHoverOnly`}>
                  Approach
                </Link>
              </li>
              <li>
                <Link to={`/services`} className={`linkHoverOnly`}>
                  Services
                </Link>
              </li>
              <li>
                <Link to={`/about`} className={`linkHoverOnly`}>
                  About Us
                </Link>
              </li>
              <li>
                <Link to={`/careers`} className={`linkHoverOnly`}>
                  Careers
                </Link>
              </li>
            </ul>
            {/* </div> */}
          </div>
        </div>
        <div className={`${privacyLink} textColorMidnight`}>
          <Link to={'/privacy-policy'} className={`meta linkHoverOnly`}>
            Privacy Statement
          </Link>
        </div>
      </section>
    </footer>
  );
};

export default Footer;
